export const DISPATCH_ENDPOINTS = {
  getDriverSchedule: '/web/gantt/api/v2/gantt/v3',
  getDriverSchedulerWarnings: '/web/gantt/api/v2/gantt/data/warnings/v5',
};
